import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import { articleCards } from "../mocks/seo-data";

const articleRoutes: RouteObject[] = articleCards.map((card) => ({
  path: card.slug,
  element: <ArticlePage />,
}));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  ...articleRoutes,
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;